'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _analytics; // import moment from 'moment-timezone';
// moment.tz.setDefault('Asia/Bangkok');


exports.default = reducer;
exports.login = login;
exports.signup = signup;
exports.logout = logout;
exports.isUserDataLoaded = isUserDataLoaded;
exports.loadUserData = loadUserData;
exports.loadSessionData = loadSessionData;
exports.openLogin = openLogin;
exports.openSignup = openSignup;
exports.openForgot = openForgot;
exports.openReset = openReset;
exports.openMobileNav = openMobileNav;
exports.openMobileQuickSearch = openMobileQuickSearch;
exports.setCancellationPolicy = setCancellationPolicy;
exports.setSessionData = setSessionData;
exports.setLocalSessionData = setLocalSessionData;
exports.facebookLogin = facebookLogin;
exports.googleLogin = googleLogin;
exports.mobileConnectLogin = mobileConnectLogin;
exports.weiboLogin = weiboLogin;
exports.registerLineNotify = registerLineNotify;
exports.clearLineNotify = clearLineNotify;
exports.sendForgot = sendForgot;
exports.postReset = postReset;
exports.openLoginSignup = openLoginSignup;
exports.openMobileApp = openMobileApp;
exports.openCountNumUser = openCountNumUser;
exports.openSubscribe = openSubscribe;
exports.openSet = openSet;
exports.checkDuplicateEmail = checkDuplicateEmail;
exports.setLoginSignupCallback = setLoginSignupCallback;
exports.loggedIn = loggedIn;
exports.setMobilePopup = setMobilePopup;
exports.setWithPromo = setWithPromo;
exports.setOldPromo = setOldPromo;
exports.setPromoInput = setPromoInput;
exports.sendUserType = sendUserType;
exports.setIsPageChanged = setIsPageChanged;
exports.setIsVisitBooking = setIsVisitBooking;
exports.searchLog = searchLog;
exports.clickCall = clickCall;
exports.setTourType = setTourType;
exports.shareFB = shareFB;

var _session = require('utils/session');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGIN = 'redux-frontend/session/LOGIN';
var SIGNUP = 'redux-frontend/session/SIGNUP';
var LOGIN_SUCCESS = 'redux-frontend/session/LOGIN_SUCCESS';
var LOGIN_FAIL = 'redux-frontend/session/LOGIN_FAIL';
var LOAD_USER_DATA = 'redux-frontend/session/LOAD_USER_DATA';
var LOAD_USER_DATA_SUCCESS = 'redux-frontend/session/LOAD_USER_DATA_SUCCESS';
var LOAD_USER_DATA_FAIL = 'redux-frontend/session/LOAD_USER_DATA_FAIL';
var LOAD_SESSION_DATA = 'redux-frontend/session/LOAD_SESSION_DATA';
var LOAD_SESSION_DATA_SUCCESS = 'redux-frontend/session/LOAD_SESSION_DATA_SUCCESS';
var LOAD_SESSION_DATA_FAIL = 'redux-frontend/session/LOAD_SESSION_DATA_FAIL';
var LOGOUT = 'redux-frontend/session/LOGOUT';
var LOGOUT_SUCCESS = 'redux-frontend/session/LOGOUT_SUCCESS';
var LOGOUT_FAIL = 'redux-frontend/session/LOGOUT_FAIL';
var OPEN_LOGIN = 'redux-frontend/session/OPEN_LOGIN';
var OPEN_SIGNUP = 'redux-frontend/session/OPEN_SIGNUP';
var OPEN_MOBILE_NAV = 'redux-frontend/session/OPEN_MOBILE_NAV';
var OPEN_MOBILE_QUICK_SEARCH = 'redux-frontend/session/OPEN_MOBILE_QUICK_SEARCH';
var OPEN_COUNT_NUM_USER = 'redux-frontend/session/OPEN_COUNT_NUM_USER';
var OPEN_SUBSCRIBE = 'redux-frontend/session/OPEN_SUBSCRIBE';
var OPEN_SET = 'redux-frontend/session/OPEN_SET';

var OPEN_FORGOT = 'redux-frontend/session/OPEN_FORGOT';
var SEND_FORGOT = 'redux-frontend/session/SEND_FORGOT';
var SEND_FORGOT_SUCCESS = 'redux-frontend/session/SEND_FORGOT_SUCCESS';
var SEND_FORGOT_FAIL = 'redux-frontend/session/SEND_FORGOT_FAIL';

var OPEN_RESET = 'redux-frontend/session/OPEN_RESET';
var POST_RESET = 'redux-frontend/session/POST_RESET';
var POST_RESET_SUCCESS = 'redux-frontend/session/POST_RESET_SUCCESS';
var POST_RESET_FAIL = 'redux-frontend/session/POST_RESET_FAIL';

var REGISTER_LINE_NOTIFY = 'redux-frontend/session/REGISTER_LINE_NOTIFY';
var REGISTER_LINE_NOTIFY_SUCCESS = 'redux-frontend/session/REGISTER_LINE_NOTIFY_SUCCESS';
var REGISTER_LINE_NOTIFY_FAIL = 'redux-frontend/session/REGISTER_LINE_NOTIFY_FAIL';

var CLEAR_LINE_NOTIFY = 'redux-frontend/session/CLEAR_LINE_NOTIFY';
var CLEAR_LINE_NOTIFY_SUCCESS = 'redux-frontend/session/CLEAR_LINE_NOTIFY_SUCCESS';
var CLEAR_LINE_NOTIFY_FAIL = 'redux-frontend/session/CLEAR_LINE_NOTIFY_FAIL';

var OPEN_LOGIN_SIGNUP = 'redux-frontend/session/OPEN_LOGIN_SIGNUP';
var SET_LOGIN_SIGNUP_CB = 'redux-frontend/session/SET_LOGIN_SIGNUP_CB';

var SET_SESSION_DATA = 'redux-frontend/session/SET_SESSION_DATA';
var SET_SESSION_DATA_SUCCESS = 'redux-frontend/session/SET_SESSION_DATA_SUCCESS';
var SET_SESSION_DATA_FAIL = 'redux-frontend/session/SET_SESSION_DATA_FAIL';

var SEND_USER_TYPE = 'redux-frontend/session/SEND_USER_TYPE';
var SEND_USER_TYPE_SUCCESS = 'redux-frontend/session/SEND_USER_TYPE_SUCCESS';
var SEND_USER_TYPE_FAIL = 'redux-frontend/session/SEND_USER_TYPE_FAIL';

var SET_LOCAL_SESSION_DATA = 'redux-frontend/session/SET_LOCAL_SESSION_DATA';
var LOGGED_IN = 'redux-frontend/session/LOGGED_IN';

var OPEN_MOBILE_APP = 'redux-frontend/session/OPEN_MOBILE_APP';
var SET_MOBILE_POPUP = 'redux-frontend/session/SET_MOBILE_POPUP';
var SET_MOBILE_POPUP_SUCCESS = 'redux-frontend/session/SET_MOBILE_POPUP_SUCCESS';
var SET_MOBILE_POPUP_FAIL = 'redux-frontend/session/SET_MOBILE_POPUP_FAIL';
var SET_WITH_PROMO = 'redux-frontend/session/SET_WITH_PROMO';
var SET_PROMO_INPUT = 'redux-frontend/session/SET_PROMO_INPUT';
var SET_IS_PAGE_CHANGED = 'redux-frontend/session/SET_IS_PAGE_CHANGED';
var SET_IS_VISIT_BOOKING = 'redux-frontend/session/SET_IS_VISIT_BOOKING';

var SET_OLD_PROMO = 'redux-frontend/session/SET_OLD_PROMO';
var SET_TOUR_TYPE = 'redux-frontend/session/SET_TOUR_TYPE';

var SEARCH_LOG = 'redux-frontend/session/SEARCH_LOG';
var CLICK_CALL = 'redux-frontend/session/CLICK_CALL';

var LOAD_COMBINED_DYNAMIC_SUCCESS = 'redux-frontend/info/LOAD_COMBINED_DYNAMIC_SUCCESS';

var SHARE_FB = 'redux-frontend/session/SHARE_FB';
// const SHARE_FB_SUCCESS = 'redux-frontend/session/SHARE_FB_SUCCESS';
// const SHARE_FB_FAIL = 'redux-frontend/session/SHARE_FB_FAIL';
var SET_CANCELLATION_POLICY = 'redux-frontend/session/SET_CANCELLATION_POLICY';
var SET_CANCELLATION_POLICY_SUCCESS = 'redux-frontend/session/SET_CANCELLATION_POLICY_SUCCESS';
var SET_CANCELLATION_POLICY_FAIL = 'redux-frontend/session/SET_CANCELLATION_POLICY_FAIL';

var CHECK_DUPLICATE_EMAIL = 'redux-frontend/session/CHECK_DUPLICATE_EMAIL';
var CHECK_DUPLICATE_EMAIL_SUCCESS = 'redux-frontend/session/CHECK_DUPLICATE_EMAIL_SUCCESS';
var CHECK_DUPLICATE_EMAIL_FAIL = 'redux-frontend/session/CHECK_DUPLICATE_EMAIL_FAIL';

var initialState = {
  loggingIn: false,
  signingUp: false,
  user: {},
  data: {
    quantity: 2,
    currency: 'THB'
    // date: moment().startOf('day').add('days', 1).toDate(),
  },
  // searchPageCount: 0,
  tourType: null,
  promoInput: '',
  oldPromo: false,
  withPromo: false,
  openLogin: false,
  openForgot: false,
  openSignup: false,
  openReset: false,
  openMobileNav: false,
  openMobileQuickSearch: false,
  openLoginSignup: false,
  loginSignUpTab: 'signup',
  openCountNumUser: false,
  openSubscribe: false,
  openSet: false,
  // openCustomizeTripPopup: false,
  isLoggedIn: false,
  isPageChanged: false,
  isVisitBooking: false,
  userDataLoaded: false,
  errorForgot: false,
  forgotSent: false,
  resetPosted: false,
  openMobileApp: false,
  settingSessionData: false,
  loadingSessionData: false,
  loginSignupCallback: function loginSignupCallback() {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        loggingIn: true,
        signingUp: true
      });
    case LOGIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        signingUp: false,
        isLoggedIn: action.result.isLoggedIn,
        user: action.result.user,
        openLogin: false,
        openSignup: false,
        openLoginSignup: false,
        userDataLoaded: true
      });
    case LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        signingUp: false,
        loginError: action.error,
        userDataLoaded: false
      });
    case LOAD_USER_DATA:
      return (0, _extends3.default)({}, state, {
        loadingUserData: true
      });
    case LOAD_USER_DATA_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingUserData: false,
        user: action.result.user || {},
        isLoggedIn: action.result.isLoggedIn,
        userDataLoaded: true
      });
    case LOAD_COMBINED_DYNAMIC_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingUserData: false,
        user: action.result.userData.user || {},
        isLoggedIn: action.result.userData.isLoggedIn,
        userDataLoaded: true,
        loadingSessionData: false,
        data: (0, _extends3.default)({}, action.result.sessionData, { date: (0, _session.getDefaultDate)(action.result.sessionData.date) })
      });
    case LOAD_USER_DATA_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingUserData: false,
        loadUserDataError: action.error,
        user: {},
        userDataLoaded: false
      });
    case LOAD_SESSION_DATA:
      return (0, _extends3.default)({}, state, {
        loadingSessionData: true
      });
    case LOAD_SESSION_DATA_SUCCESS:
      // let date;
      // if (action.result.date) {
      //   const defaultDate = moment().startOf('day').add(1, 'days').toDate();
      //   if (moment(action.result.date).isBefore(moment(defaultDate), 'day')) {
      //     date = defaultDate;
      //   } else {
      //     date = action.result.date;
      //   }
      // }
      return (0, _extends3.default)({}, state, {
        loadingSessionData: false,
        data: (0, _extends3.default)({}, action.result, { date: (0, _session.getDefaultDate)(action.result.date) // Ask trus to put it in API
        }) });
    case LOAD_SESSION_DATA_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingSessionData: false,
        loadSessionDataError: action.error
      });
    case LOGOUT:
      return (0, _extends3.default)({}, state);
    case LOGOUT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        user: {},
        isLoggedIn: false
      });
    case LOGOUT_FAIL:
      return (0, _extends3.default)({}, state);
    case OPEN_FORGOT:
      return (0, _extends3.default)({}, state, {
        errorForgot: false,
        forgotSent: false,
        openLogin: false,
        openLoginSignup: false,
        openForgot: action.open
      });
    case OPEN_RESET:
      return (0, _extends3.default)({}, state, {
        openReset: action.open
      });
    case OPEN_LOGIN:
      return (0, _extends3.default)({}, state, {
        openLogin: action.open
      });
    case OPEN_SIGNUP:
      return (0, _extends3.default)({}, state, {
        openSignup: action.open
      });
    case OPEN_MOBILE_NAV:
      return (0, _extends3.default)({}, state, {
        openMobileNav: action.open
      });
    case OPEN_MOBILE_QUICK_SEARCH:
      return (0, _extends3.default)({}, state, {
        openMobileQuickSearch: action.open
      });
    case OPEN_MOBILE_APP:
      return (0, _extends3.default)({}, state, {
        openMobileApp: action.open
      });
    case OPEN_LOGIN_SIGNUP:
      return (0, _extends3.default)({}, state, {
        openLoginSignup: action.open,
        loginSignUpTab: action.window
      });
    case OPEN_COUNT_NUM_USER:
      return (0, _extends3.default)({}, state, {
        openCountNumUser: action.open
      });
    case OPEN_SUBSCRIBE:
      return (0, _extends3.default)({}, state, {
        openSubscribe: action.open
      });
    case OPEN_SET:
      return (0, _extends3.default)({}, state, {
        openSet: action.open
      });
    case SET_CANCELLATION_POLICY_SUCCESS:
      return (0, _extends3.default)({}, state, {
        user: action.result
      });
    case POST_RESET_SUCCESS:
      return (0, _extends3.default)({}, state, {
        resetPosted: true
      });
    case SEND_FORGOT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        forgotSent: true,
        errorForgot: false
      });
    case SEND_FORGOT_FAIL:
      return (0, _extends3.default)({}, state, {
        errorForgot: true
      });
    case SET_LOCAL_SESSION_DATA:
      return (0, _extends3.default)({}, state, {
        data: (0, _extends3.default)({}, state.data, action.object)
      });
    case SET_SESSION_DATA:
      return (0, _extends3.default)({}, state, {
        settingSessionData: true,
        data: action.forceSet ? (0, _extends3.default)({}, state.data, action.data) : state.data
      });
    case SET_SESSION_DATA_SUCCESS:
      return (0, _extends3.default)({}, state, {
        settingSessionData: false
      });
    case SET_SESSION_DATA_FAIL:
      return (0, _extends3.default)({}, state, {
        settingSessionData: false
      });
    case SET_LOGIN_SIGNUP_CB:
      return (0, _extends3.default)({}, state, {
        loginSignupCallback: action.callback
      });
    case SET_OLD_PROMO:
      return (0, _extends3.default)({}, state, {
        oldPromo: action.active
      });
    case SET_WITH_PROMO:
      return (0, _extends3.default)({}, state, {
        withPromo: action.active
      });
    case SET_PROMO_INPUT:
      return (0, _extends3.default)({}, state, {
        promoInput: action.promo
      });
    case SIGNUP:
      return (0, _extends3.default)({}, state, {
        signingUp: true
      });
    case SET_TOUR_TYPE:
      return (0, _extends3.default)({}, state, {
        tourType: action.tourType
      });
    case SET_IS_PAGE_CHANGED:
      return (0, _extends3.default)({}, state, {
        isPageChanged: action.active
      });
    case SET_IS_VISIT_BOOKING:
      return (0, _extends3.default)({}, state, {
        isVisitBooking: action.active
      });
    default:
      return state;
  }
}

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, OPEN_LOGIN_SIGNUP, function (action) {
  return action.open ? { name: 'Open Login/Signup', category: 'Session', virtualPath: '/virtual/open-login-signup' } : null;
}), (0, _defineProperty3.default)(_analytics, OPEN_LOGIN, function (action) {
  return action.open ? { name: 'Open Login', category: 'Session', virtualPath: '/virtual/open-login' } : null;
}), (0, _defineProperty3.default)(_analytics, OPEN_SIGNUP, function (action) {
  return action.open ? { name: 'Open Signup', category: 'Session', virtualPath: '/virtual/open-signup' } : null;
}), (0, _defineProperty3.default)(_analytics, LOGGED_IN, function () {
  return { name: 'Logged In', category: 'Session', loggedIn: true };
}), (0, _defineProperty3.default)(_analytics, LOGOUT_SUCCESS, function () {
  return { name: 'Logged Out', category: 'Session', loggedOut: true };
}), (0, _defineProperty3.default)(_analytics, OPEN_MOBILE_NAV, function (action) {
  return action.open ? { name: 'Open Mobile Nav', category: 'Session' } : { name: 'Close Mobile Nav', category: 'Session' };
}), (0, _defineProperty3.default)(_analytics, OPEN_MOBILE_QUICK_SEARCH, function (action) {
  return action.open ? { name: 'Open Mobile Quick Search', category: 'Session' } : { name: 'Close Mobile Quick Search', category: 'Session' };
}), (0, _defineProperty3.default)(_analytics, SEARCH_LOG, function (action) {
  return { name: 'Home Search Log', category: 'Session', destination: action.destination, activities: action.activities };
}), (0, _defineProperty3.default)(_analytics, CLICK_CALL, function () {
  return { name: 'Click Call', category: 'Session' };
}), (0, _defineProperty3.default)(_analytics, SHARE_FB, function () {
  return { name: 'Share Facebook', category: 'Referral' };
}), _analytics);

function login(data) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/session/login', {
        data: data
      }).then(function (result) {
        if (!result.access_token) {
          return _promise2.default.resolve({
            isLoggedIn: false,
            loggingIn: false,
            user: {}
          });
        }
        return client.get('/users/me').then(function (userData) {
          if (window.zE && window.zE.identify) {
            window.zE.identify({
              name: userData.user.name.first + ' ' + userData.user.name.last,
              email: userData.user.email
            });
          }
          return userData;
        });
      });
    },
    meta: {
      analytics: ''
    }
  };
}

function signup(data) {
  return {
    types: [SIGNUP, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/session/signup', {
        data: data
      }).then(function (result) {
        if (!result.access_token) {
          return _promise2.default.resolve({
            isLoggedIn: false,
            user: {}
          });
        }
        return client.get('/users/me').then(function (userData) {
          if (window.zE && window.zE.identify) {
            window.zE.identify({
              name: userData.user.name.first + ' ' + userData.user.name.last,
              email: userData.user.email
            });
          }
          return userData;
        });
      });
    },
    meta: {
      analytics: ''
    }
  };
}

function logout() {
  return {
    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: function promise(client) {
      return client.del('/session/logout');
    },
    meta: {
      analytics: ''
    }
  };
}
function isUserDataLoaded(globalState) {
  return globalState.session && globalState.session.userDataLoaded;
}

function loadUserData() {
  return {
    types: [LOAD_USER_DATA, LOAD_USER_DATA_SUCCESS, LOAD_USER_DATA_FAIL],
    promise: function promise(client) {
      return client.get('/users/me');
    }
  };
}

function loadSessionData() {
  return {
    types: [LOAD_SESSION_DATA, LOAD_SESSION_DATA_SUCCESS, LOAD_SESSION_DATA_FAIL],
    promise: function promise(client) {
      return client.get('/session/data');
    }
  };
}

function openLogin() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_LOGIN,
    open: open,
    meta: {
      analytics: ''
    }
  };
}

function openSignup() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_SIGNUP,
    open: open,
    meta: {
      analytics: ''
    }
  };
}

function openForgot() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_FORGOT,
    open: open
  };
}

function openReset() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_RESET,
    open: open
  };
}

function openMobileNav() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_MOBILE_NAV,
    open: open
  };
}
function openMobileQuickSearch() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_MOBILE_QUICK_SEARCH,
    open: open
  };
}

function setCancellationPolicy() {
  return {
    types: [SET_CANCELLATION_POLICY, SET_CANCELLATION_POLICY_SUCCESS, SET_CANCELLATION_POLICY_FAIL],
    promise: function promise(client) {
      return client.post('/users/accept-cancellation-policy');
    }
  };
}

function setSessionData(data) {
  var forceSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return {
    types: [SET_SESSION_DATA, SET_SESSION_DATA_SUCCESS, SET_SESSION_DATA_FAIL],
    promise: function promise(client) {
      return client.post('/session/data', { data: data });
    },
    data: data,
    forceSet: forceSet
  };
}

function setLocalSessionData(object) {
  return {
    type: SET_LOCAL_SESSION_DATA,
    object: object
  };
}

function facebookLogin(accessToken) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/session/login/provider/facebook', {
        data: { accessToken: accessToken }
      }).then(function (result) {
        if (!result.access_token) {
          return _promise2.default.resolve({
            isLoggedIn: false,
            loggingIn: false,
            user: {}
          });
        }
        return _promise2.default.resolve({
          isLoggedIn: true,
          loggingIn: false,
          user: result.user
        }).then(function (userData) {
          if (window.zE && window.zE.identify) {
            window.zE.identify({
              name: userData.user.name.first + ' ' + userData.user.name.last,
              email: userData.user.email
            });
          }
          return userData;
        });
      });
    }
  };
}

function googleLogin(idToken) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/session/login/provider/google', {
        data: {
          id_token: idToken
        }
      }).then(function (result) {
        if (!result.access_token) {
          return _promise2.default.resolve({
            isLoggedIn: false,
            loggingIn: false,
            user: {}
          });
        }
        return _promise2.default.resolve({
          isLoggedIn: true,
          loggingIn: false,
          user: result.user
        }).then(function (userData) {
          if (window.zE && window.zE.identify) {
            window.zE.identify({
              name: userData.user.name.first + ' ' + userData.user.name.last,
              email: userData.user.email
            });
          }
          return userData;
        });
      });
    }
  };
}

function mobileConnectLogin(data) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/session/login/provider/mobileconnect', {
        data: data
      }).then(function (result) {
        if (!result.access_token) {
          return _promise2.default.resolve({
            isLoggedIn: false,
            loggingIn: false,
            user: {}
          });
        }
        return _promise2.default.resolve({
          isLoggedIn: true,
          loggingIn: false,
          user: result.user
        }).then(function (userData) {
          if (window.zE && window.zE.identify) {
            window.zE.identify({
              name: userData.user.name.first + ' ' + userData.user.name.last,
              email: userData.user.email
            });
          }
          return userData;
        });
      });
    }
  };
}

function weiboLogin(data) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/session/login/provider/weibo', {
        data: data
      }).then(function (result) {
        if (!result.access_token) {
          return _promise2.default.resolve({
            isLoggedIn: false,
            loggingIn: false,
            user: {}
          });
        }
        return _promise2.default.resolve({
          isLoggedIn: true,
          loggingIn: false,
          user: result.user
        }).then(function (userData) {
          if (window.zE && window.zE.identify) {
            window.zE.identify({
              name: userData.user.name.first + ' ' + userData.user.name.last,
              email: userData.user.email
            });
          }
          return userData;
        });
      });
    }
  };
}

function registerLineNotify(code) {
  return {
    types: [REGISTER_LINE_NOTIFY, REGISTER_LINE_NOTIFY_SUCCESS, REGISTER_LINE_NOTIFY_FAIL],
    promise: function promise(client) {
      return client.post('/session/login/provider/line-notify', {
        data: { code: code }
      });
    }
  };
}

function clearLineNotify() {
  return {
    types: [CLEAR_LINE_NOTIFY, CLEAR_LINE_NOTIFY_SUCCESS, CLEAR_LINE_NOTIFY_FAIL],
    promise: function promise(client) {
      return client.del('/session/login/provider/line-notify');
    }
  };
}

function sendForgot(data) {
  return {
    types: [SEND_FORGOT, SEND_FORGOT_SUCCESS, SEND_FORGOT_FAIL],
    promise: function promise(client) {
      return client.post('/users/mail/forgot', { data: data });
    }
  };
}

function postReset(token, password) {
  return {
    types: [POST_RESET, POST_RESET_SUCCESS, POST_RESET_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/reset-password', { data: { token: token, password: password } });
    }
  };
}

function openLoginSignup() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'signup';

  return {
    type: OPEN_LOGIN_SIGNUP,
    open: open,
    window: window,
    meta: {
      analytics: ''
    }
  };
}

function openMobileApp() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_MOBILE_APP,
    open: open
  };
}

function openCountNumUser() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_COUNT_NUM_USER,
    open: open
  };
}

function openSubscribe() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_SUBSCRIBE,
    open: open
  };
}

function openSet() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_SET,
    open: open
  };
}

function checkDuplicateEmail(email) {
  return {
    types: [CHECK_DUPLICATE_EMAIL, CHECK_DUPLICATE_EMAIL_SUCCESS, CHECK_DUPLICATE_EMAIL_FAIL],
    promise: function promise(client) {
      return client.post('/info/email/check', { data: { email: email } });
    }
  };
}

function setLoginSignupCallback(callback) {
  return {
    type: SET_LOGIN_SIGNUP_CB,
    callback: callback
  };
}

function loggedIn(userId) {
  return {
    type: LOGGED_IN,
    userId: userId
  };
}

function setMobilePopup() {
  var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return {
    types: [SET_MOBILE_POPUP, SET_MOBILE_POPUP_SUCCESS, SET_MOBILE_POPUP_FAIL],
    promise: function promise(client) {
      return client.post('/users/me', { data: { show_mobile_popup: bool } });
    }
  };
}

function setWithPromo() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: SET_WITH_PROMO,
    active: active
  };
}

function setOldPromo() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: SET_OLD_PROMO,
    active: active
  };
}

function setPromoInput() {
  var promo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    type: SET_PROMO_INPUT,
    promo: promo
  };
}

function sendUserType(data) {
  return {
    types: [SEND_USER_TYPE, SEND_USER_TYPE_SUCCESS, SEND_USER_TYPE_FAIL],
    promise: function promise(client) {
      return client.post('/session/data', { data: data });
    }
  };
}

function setIsPageChanged() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: SET_IS_PAGE_CHANGED,
    active: active
  };
}
function setIsVisitBooking() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: SET_IS_VISIT_BOOKING,
    active: active
  };
}

function searchLog() {
  var destination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var activities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return {
    type: SEARCH_LOG,
    destination: destination,
    activities: activities
  };
}

function clickCall() {
  return {
    type: CLICK_CALL
  };
}

function setTourType(tourType) {
  return {
    type: SET_TOUR_TYPE,
    tourType: tourType
  };
}

function shareFB() {
  return {
    // types: [SHARE_FB, SHARE_FB_SUCCESS, SHARE_FB_FAIL],
    // promise: (client) => client.post('/users/me/share-facebook'),
    type: SHARE_FB
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/session.js
// module id = 22
// module chunks = 47